module.exports = __webpack_public_path__ + "img/fishing-min.11141e78.jpg";